<div class="wrapper" *transloco="let t">
  <div class="content">
    <h2 class="title">{{ title }}</h2>
    <ng-content></ng-content>
  </div>

  <div class="form-check form-switch mb-0" *ngIf="showDontShowAgain">
    <input
      id="isophi-info-popup-dont-show"
      class="form-check-input"
      type="checkbox"
      role="switch"
      [checked]="dontShowAgain"
      (change)="onCheckboxChange($event)"
    />
    <label class="form-check-label" for="isophi-info-popup-dont-show">
      {{ t('shared/dontShowAgain') }}
    </label>
  </div>

  <div class="actions-wrapper">
    <ng-content select="[slot=actions]"></ng-content>
  </div>

  <button *ngIf="continueLabel" (click)="onContinue()" class="btn btn-lg btn-primary continue-btn">
    {{ continueLabel }}
  </button>
</div>
